import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const PAGE_OPENED = 'page/PAGE_OPENED';

export const pageOpened = createAction(PAGE_OPENED);
